import React from 'react';
import { WidgetConfig } from '../../types';
import getResource from '../../helpers/get-resource';
import getField from '../../helpers/get-field';
import useResource from '../../../section-dashboard/hooks/widget/use-resource';

import CreateAWidgetPreviewMessage from '../../create-a-widget/components/create-a-widget-preview-message';
import useResourceSparkLine from '../../../section-dashboard/hooks/widget/use-resource-spark-line';
import WidgetSparkLine from '../../../section-dashboard/widgets/widget/widget-spark-line';
import useResourceTotal from '../../../section-dashboard/hooks/widget/use-resource-total';
import { WidgetColour } from '../../../section-dashboard/types';

const WidgetPreviewSparkline = ({ config }: { config: WidgetConfig }) => {
    // Get the request values from the widget
    const resource = getResource(config.resource);
    const graphMetricField = config.graph_metrics && getField(config.graph_metrics);
    const widgetColor = config.widget_color;

    const resourceData = useResource({
        resource: resource,
        request: {
            isGraph: true,
            orderBy: resource ? [{ field: resource?.dateDimension, orderByDirection: 'asc' }] : [],
            groupBy: resource?.dateDimension,
            graphGroupBy: resource ? [resource?.dateDimension] : [],
            graphMetrics: graphMetricField ? [graphMetricField] : [],
            enabled: !!resource,
        },
    });

    const sparklineData = useResourceSparkLine({
        resourceData: resourceData,
        metric: graphMetricField || undefined,
        dateDimension: resource?.dateDimension,
    });

    const resourceTotalData = useResource({
        resource: resource,
        request: {
            orderBy: resource ? [{ field: resource?.dateDimension, orderByDirection: 'asc' }] : [],
            groupBy: resource?.dateDimension,
            totals: true,
            enabled: !!resource,
        },
    });

    const totalData = useResourceTotal({
        resourceData: resourceTotalData,
    });

    if (config.graph_metrics && config.graph_metrics.length > 0) {
        return (
            <WidgetSparkLine
                title={config.widget.title}
                data={sparklineData}
                totalData={totalData}
                colour={WidgetColour[widgetColor as keyof typeof WidgetColour]}
            />
        );
    }

    return <CreateAWidgetPreviewMessage message="Please select a metric to preview the Sparkline graph" />;
};

export default WidgetPreviewSparkline;
